import { Button, Checkbox, Drawer, Modal, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CloseIcon } from '../../assets/icons';
import useLegal from '../../Hooks/useLegal';
import useMediaQuery from '../../Hooks/useMediaQuery';
import { acceptAgreementApi } from '../../services/authApi/userApi';
import { resetPolicyDetails } from '../../store/reducer/legalSlice';
import { createMarkup } from '../../utils/createMarkup';
import { POLICY_AGREEMENTS, POLICY_AGREEMENTS_TITLE } from '../../utils/policy.constants';
import { toastNotify } from '../../utils/toastNotify';

export default function ListingAgreement({ isOpen, onAgreementAccept, onClose }) {
  const dispatch = useDispatch();
  const screenMD = useMediaQuery('(min-width: 1000px)');

  const { fetchPolicyByEnum, isFetchingPolicy, policyDetails } = useLegal({ shouldFetchTypes: false });

  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPolicyByEnum(POLICY_AGREEMENTS.SECONDARY_LISTING_AGREEMENT);

    return () => {
      dispatch(resetPolicyDetails());
    };
  }, []);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const renderModalContent = () => {
    return (
      <Spin spinning={isFetchingPolicy}>
        <div className='agreement-content fz-14'>
          <div className={screenMD ? 'pb-16 px-48' : 'p-24'} dangerouslySetInnerHTML={createMarkup(policyDetails?.content)} />
          <div className='checks mb-24'>
            <Checkbox disabled={isFetchingPolicy} onChange={handleCheckboxChange}>
              I have read and accept the secondary list agreement.
            </Checkbox>
          </div>
        </div>
      </Spin>
    );
  };

  const handleAgreeTerms = async () => {
    setLoading(true);
    try {
      const response = await acceptAgreementApi(POLICY_AGREEMENTS.SECONDARY_LISTING_AGREEMENT, isChecked);
      if (response?.data?.isError) {
        toastNotify('error', response?.data?.message);
      } else {
        onAgreementAccept();
      }
    } catch (error) {
      toastNotify('error', error?.response?.data?.message ?? 'Something went wrong!');
    } finally {
      setLoading(false);
    }
  };

  const renderFooter = () => {
    return (
      <Button type='primary' loading={loading} className='w-100' disabled={!isChecked || loading} onClick={handleAgreeTerms}>
        Agree to terms
      </Button>
    );
  };

  if (screenMD) {
    return (
      <Modal
        className='quickbuy agreement-modal ant-modal--footer-shadow ant-modal--both'
        open={isOpen}
        title={POLICY_AGREEMENTS_TITLE.SECONDARY_LISTING_AGREEMENT}
        width={650}
        destroyOnClose={true}
        closeIcon={<CloseIcon onClick={onClose} />}
        footer={renderFooter()}
        centered
      >
        {renderModalContent()}
      </Modal>
    );
  } else {
    return (
      <Drawer
        className='agreement footer-shadow quickbuy--drawer'
        width='100%'
        open={isOpen}
        title={
          <>
            <span className='subhead-2 mb-0 ml-24 text-center title'>{POLICY_AGREEMENTS_TITLE.SECONDARY_LISTING_AGREEMENT}</span>
          </>
        }
        closeIcon={<CloseIcon onClick={onClose}/>}
        footer={renderFooter()}
        centered
      >
        {renderModalContent()}
      </Drawer>
    );
  }
}
